<template>
  <v-card>
    <v-container fluid>
      <v-dialog v-model="viewActionsDialog">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on"></v-icon>
        </template>
        <v-card>
          <v-card-title>
            <v-toolbar dark>
              Actions Taken
              <v-spacer />
              <v-btn icon @click="viewActionsDialog = false">
                <v-icon>mdi-close</v-icon></v-btn
              >
            </v-toolbar>
          </v-card-title>
          <v-card-text>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Action</th>
                    <th>Action Taken By</th>
                    <th>Date</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="action in actions_taken" :key="action.id">
                    <td>{{ action.actionTaken }}</td>
                    <td>{{ action.actionTakenBy }}</td>
                    <td>{{ new Date(action.date).toLocaleDateString() }}</td>
                    <td>{{ action.notes }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-data-table
        :headers="disciplineHeaders"
        :items="referrals"
        :items-per-page="20"
        :search="search"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        show-expand
        class="elevation-1"
      >
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">Details: {{ item.explanations }}</td>
        </template>
        <template v-slot:top>
          <v-spacer />
          <v-col cols="12" lg="4" md="4" sm="">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              hide-details
            />
          </v-col>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-chip
            @click="viewAction(item)"
            v-if="item.actions_taken.length > 0"
            color="green lighten-2"
          >
            Actions Taken
          </v-chip>
          <v-chip v-else> No actions yet </v-chip>
        </template>
        <template v-slot:[`item.incident_time`]="{ item }">
          {{ new Date(item.incident_time).toLocaleDateString() }}
        </template>
      </v-data-table>
    </v-container>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    viewActionsDialog: false,
    search: null,
    referrals: [],
    singleExpand: true,
    expanded: [],
    selectedStudentName: null,
    actions_taken: [],
    disciplineHeaders: [
      { text: "", value: "data-table-expand" },
      { text: "Incident", value: "incident" },
      { text: "Location", value: "incident_location" },
      { text: "Teacher", value: "teacher_name" },
      { text: "Date/Time", value: "incident_time" },
      { text: "Admin Actions", value: "actions", sortable: false },
    ],
  }),
  computed: {},
  methods: {
    viewAction(item) {
      this.viewActionsDialog = true;
      this.selectedStudentName = item.student_name;
      this.actions_taken = [...item.actions_taken];
    },
    getDisciplineRefs() {
      this.$sisApi("get", `my-schedule/discipline/self`)
        .then((response) => {
          this.referrals = response.data;
        })
        .catch((error) => {
          this.snackbar = true;
          this.snackbar_text = error.response.data.message;
        });
    },
  },
  mounted() {
    this.getDisciplineRefs();
  },
};
</script>